import React, { useState } from 'react';
import { Polyline, Circle, OverlayView } from '@react-google-maps/api';

import Tooltip from '@mui/material/Tooltip';

import { colors } from 'theme/colors';

import { BreadCrumbsProps, CircleMarkerProps } from './types';

import { getPixelPositionOffset } from '../Marker/utils';

import { RoundBox } from './styles';

const CircleMarker: React.FC<CircleMarkerProps> = ({ el }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => {
    setOpen((prevState) => !prevState);
  };

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={{ lat: el.lat, lng: el.lng }}
      getPixelPositionOffset={getPixelPositionOffset}
    >
      <>
        <Tooltip placement="right" open={open} title={`${el.lat}, ${el.lng}`}>
          <RoundBox />
        </Tooltip>
        <Circle
          key={el.uuid}
          center={el}
          radius={6}
          options={{
            fillOpacity: 1,
            fillColor: colors.primary.main,
            strokeColor: colors.primary.main,
            strokeOpacity: 1,
            strokeWeight: 1,
          }}
          onMouseOver={handleOpen}
          onMouseOut={handleOpen}
        />
      </>
    </OverlayView>
  );
};

const BreadCrumbs: React.FunctionComponent<BreadCrumbsProps> = ({ path }) => (
  <>
    <Polyline
      path={path}
      options={{
        strokeColor: colors.primary.main,
        strokeWeight: 2,
        strokeOpacity: 1,
      }}
    />
    {path.map((el) => (
      <CircleMarker el={el} key={el.uuid} />
    ))}
  </>
);

export default BreadCrumbs;
